import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { RELATED_PARTY_TYPES } from '../../constants';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';

const {
  formField: { principalType, principalOccupation },
} = loanFormModel;

export class PrincipalOccupationValidation implements ValidationSchema {
  public name = principalOccupation.name;
  public label = principalOccupation.label;
  public dependsOn: string[] = [principalType.name];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public when(principalType: string, schema) {
    if (principalType === RELATED_PARTY_TYPES.INDIVIDUAL) {
      return schema.required(principalOccupation.requiredErrorMsg);
    }
    return schema.notRequired();
  }
}
export default new Validation(new PrincipalOccupationValidation());
